import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authSlice from './slices/authSlice';
import annualReportSlice from './slices/annualReportSlice';
import financialStatementSlice from './slices/financialStatementSlice';
import hierarchySlice from './slices/hierarchySlice';
import riskAssessmentSlice from './slices/riskAssessmentSlice';
import controlActivitiesSlice from './slices/controlActivitiesSlice';
import gapsSlice from './slices/gapsSlice';
import certificationSlice from './slices/certificationSlice';
import cosoComplianceSlice from './slices/cosoComplianceSlice';
import auditPlanSlice from './slices/auditPlanSlice';
import changeLogSlice from './slices/changeLogSlice';
import companySlice from './slices/companySlice';
import usersSlice from './slices/usersSlice';
import generalSlice from './slices/generalSlice';
import { resetReduxState } from './actions';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    annualReport: annualReportSlice,
    financialStatement: financialStatementSlice,
    hierarchy: hierarchySlice,
    riskAssessment: riskAssessmentSlice,
    controlActivities: controlActivitiesSlice,
    gaps: gapsSlice,
    certification: certificationSlice,
    cosoCompliance: cosoComplianceSlice,
    auditPlan: auditPlanSlice,
    changeLog: changeLogSlice,
    company: companySlice,
    users: usersSlice,
    general: generalSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: import.meta.env.VITE_ENABLE_REDUX_DEVTOOLS === 'true',
});

// Setup listeners for RTK Query (when we add it)
setupListeners(store.dispatch);

// Listen to auth:logout event from apiClient
if (typeof window !== 'undefined') {
  window.addEventListener('auth:logout', () => {
    // console.log('🚪 Received auth:logout event, clearing all Redux state');
    store.dispatch(resetReduxState());
  });
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export { resetReduxState }; 